import React, { ReactNode, useState } from 'react';
import Modal from 'react-modal';
import { CloseOutlineIcon } from 'cokitchen-icons';
import { Button, ToastMessage } from '@cokitchen/cokitchen-components';
import { apiService } from 'services/base.service';
import { BrandOption } from 'utils/types';
import { toast } from 'react-toastify';
import SelectBrand from 'components/select-brand';

type DataType = {
  name: string;
  meal_category_id: string;
};
type DuplicateMealCategoryprops = {
  show: boolean;
  children?: ReactNode;
  onClose: () => void;
  mealCategory: DataType;
};

const customStyles = {
  content: {
    top: '50%',
    left: '50%',
    right: 'auto',
    bottom: 'auto',
    marginRight: '-50%',
    transform: 'translate(-50%, -50%)',
    borderRadius: '10px',
    backgroundColor: '#fff',
    border: 'none',
    padding: '0px',
    overflow: 'unset',
    maxWidth: '400px',
    width: '60%'
  },
  overlay: {
    background: 'rgba(0, 0, 0, 0.4)',
    backdropFilter: 'blur(3px)',
    zIndex: 10000
  }
};

const DuplicateMealCategoryModal = ({
  show,
  onClose,
  mealCategory
}: DuplicateMealCategoryprops) => {
  const [selectedBrand, setSelectedBrand] = useState([] as BrandOption[] | undefined);
  const [loading, setLoading] = useState(false);

  const duplicateMealCategory = async () => {
    setLoading(true);
    const selectedBrandIds = selectedBrand?.map((item) => item.value);
    try {
      const payload = {
        meal_category_id: mealCategory.meal_category_id,
        brand_ids: selectedBrandIds
      };
      const res = await apiService.post(`marketing/duplicate-meal-category`, { data: payload });
      if (res?.data) {
        toast(
          <ToastMessage type='success' message={`${mealCategory?.name} duplicated successfully`} />
        );
        onClose();
      }
    } catch (err: any) {
      toast(<ToastMessage type='error' message={err?.response?.data?.message} />);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Modal isOpen={show} style={customStyles} ariaHideApp={false}>
      <div className='pb-8 px-5 space-y-5 text-[#1A1A1A] bg-white rounded-[10px]'>
        <div className='flex justify-between items-center border-b border-solid border-[#e0dadb] py-4 -mx-[1.2rem] '>
          <div></div>
          <h2 className='font-medium '>Duplicate {mealCategory.name}</h2>
          <div className='flex justify-center items-center rounded-full bg-[#EFF0F0] mr-3 w-5 h-5'>
            <CloseOutlineIcon className='cursor-pointer' onClick={onClose} />
          </div>
        </div>

        <div>
          <p className='mb-2'>Select brand</p>
          <SelectBrand brands={selectedBrand || []} setBrands={setSelectedBrand} multiple />
        </div>

        <div className='flex justify-center '>
          <Button
            onClick={duplicateMealCategory}
            className=' h-[40px] mt-9'
            color='primary'
            variant='block'
            loading={loading}
            disabled={selectedBrand?.length === 0}>
            Update
          </Button>
        </div>
      </div>
    </Modal>
  );
};

export default DuplicateMealCategoryModal;
